export default __webpack_public_path__ + "static/course-testimonial-bg-f9b5fe60ab62a262c6c696bdcb403a6b.png";